import { RouteMap } from 'routes/router';

export const workOrdersSubroutes = {
    new: 'new'
} as const satisfies RouteMap;
